import { render } from "./AuthorizationComponent.vue?vue&type=template&id=3049484e&scoped=true"
import script from "./AuthorizationComponent.vue?vue&type=script&lang=js"
export * from "./AuthorizationComponent.vue?vue&type=script&lang=js"

import "./AuthorizationComponent.vue?vue&type=style&index=0&id=3049484e&scoped=true&lang=css"
import "./AuthorizationComponent.vue?vue&type=style&index=1&id=3049484e&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3049484e"]])

export default __exports__